/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { LOCATION_CHANGE } from 'connected-react-router';

import {
  CLEAR_INVALID_FIELDS,
  CLEAR_TOUCHED_FIELDS,
  CONTACT_INFO_SAVED,
  FIELD_IS_VALID,
  FIELD_IS_INVALID,
  RECEIVED_ADDRESS_VALIDATION,
  TOUCHED_FIELD
} from 'state/validation/ValidationActions';

export const invalidFieldsInitialState = {};

export const invalidFieldsReducer = (
  state = invalidFieldsInitialState,
  action
) => {
  if (action.type === FIELD_IS_VALID) {
    const newState = {
      ...state
    };
    delete newState[action.field];
    return newState;
  }

  if (action.type === FIELD_IS_INVALID) {
    return {
      ...state,
      [action.field]: action.reason === undefined ? true : action.reason
    };
  }

  if (
    action.type === LOCATION_CHANGE ||
    action.type === CLEAR_INVALID_FIELDS
  ) {
    return invalidFieldsInitialState;
  }

  return state;
};

export const touchedFieldsInitialState = {};

export const touchedFieldsReducer = (
  state = touchedFieldsInitialState,
  action
) => {
  if (action.type === TOUCHED_FIELD) {
    return {
      ...state,
      [action.field]: true
    };
  }

  if (
    action.type === LOCATION_CHANGE ||
    action.type === CLEAR_TOUCHED_FIELDS 
  ) {
    return touchedFieldsInitialState;
  }

  return state;
};

export const validatedAddressInitialState = {};

export const validatedAddressReducer = (
  state = validatedAddressInitialState,
  action
) => {
  if (action.type === RECEIVED_ADDRESS_VALIDATION) {
    return action.address;
  }

  return state;
};

export const contactInfoWasSavedReducer = (state = false, action) => {
  if (action.type === CONTACT_INFO_SAVED) {
    return action.wasSaved;
  }

  if (action.type === LOCATION_CHANGE) {
    return false;
  }
  return state;
};
